import React, { useState } from "react";
import { handlePauseAllVideo,removeStylesFromHtml } from "../../utils";
import { ReactComponent as ArrowUpIcon } from "../../Icons/arrowUp.svg";
import { ReactComponent as ArrowDownIcon } from "../../Icons/arrowDown.svg";
import { ReactComponent as RFUIcon } from "../../Icons/rfuIcon.svg";
import { ReactComponent as VerifyIcon } from "../../Icons/verify.svg";
import { ReactComponent as CopyIcon } from "../../Icons/copy.svg";
import { ReactComponent as ShareIcon } from "../../Icons/share.svg";
import Voting from "../../NewComponent/Voting/Voting"
import Button2 from "../../NewComponent/Button2/Button2"
import { useDispatch, useSelector } from "react-redux";
import { requestForUpdate } from "../../API/api";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import ImgCarousal from "../../NewComponent/Carousal/carousal";
import Button from "../../NewComponent/Button/Button"
import { CURRENT_ROLE } from "../../API/url";
import { message } from "antd";
import Rating from "../../NewComponent/Rating/Rating";

const contentStyle = {
  border: "1px solid #E0E2E6",
  borderRadius: "16px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  width:'100%'
};
export default function Answer({ data, question,val }) {
  const [messageApi, contextHolder] = message.useMessage();

  const randomNumber = Math.random()*10;
  const dispatch = useDispatch();
  const {advanceFilterModalToggle, getSelectedQuestion, getSelectedAnswer} = bindActionCreators(Actions, dispatch)
  const successfulHelpful = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
  const userState = useSelector((state) => state.user);
  const [permission, setPermission] =useState(userState.roles.find(data=>data.roleName===CURRENT_ROLE).permissions.find(item=>item.id===9));
  const searchState = useSelector((state) => state.search);
  const [isAccept, setAccept] = useState(null);
  const [isPlay, setPlay] = useState(false);
  const [isShow, setShow] = useState(false);
  const trimString = (str) => {
    if (str.length > 350) {
      return str.slice(0, 350) + "...";
    }
    return str;
  };
  const ansStyles = {
    marginTop: "10px",
    fontSize: "15px",
    color: "#5C667B",
    lineHeight: "24px",
    fontWeight: "300",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const showMoreStyles = {
    fontSize: "15px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "500",
    background:
      "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
    backgroundClip: "text",
    "-webkit-text-fill-color": "transparent",
    "-moz-text-fill-color": "transparent",
    "-ms-text-fill-color": "transparent",
    "-o-text-fill-color": "transparent",
    cursor: "pointer",
    marginTop: "5px",
  };

  const showThreadStyles = {
    fontSize: '15px',
    color: 'rgb(92, 102, 123)',
    lineHeight: '20px',
    fontWeight: 400,
    background: 'linear-gradient(90.39deg, rgb(0, 209, 255) 0.34%, rgb(0, 117, 255) 99.7%)',
    WebkitTextFillColor: 'transparent',
    cursor: 'pointer',
    marginTop: '5px',
    backgroundClip:'text'  };
  const onClickVote = (key) => {
    setAccept(key);
    let payload = {
      questionUuid: question.questionUuidCopy,
      answerUuid: data.answerUuid,
      status: key === 1 ? "accepted" : "reject",
      questionText: searchState.inputValue,
    };
    if (question.docType === "expertqa") {
      payload["botQuestionText"] = question.question;
      payload["answerText"] = data.answerCopy;
      payload["pdfId"] = "";
    } else if (question.docType === "Thread") {
      payload["answerText"] = data.threads.join(",");
      payload["pdfId"] = "";
    } else {
      payload["answerText"] = data.answerCopy;
      payload["pdfId"] = data?.attachments[0]?.name?.split(".")[0];
    }
    searchState.expertData.filter(obj=>{
      obj.answers.filter(ans=>{
        if(ans.answerUuid===data.answerUuid){
          if(key !==1){
            ans.isReject= true;
            ans.isHelpful= false;
          }else{
            ans.isHelpful= true;
            ans.isReject= false;
          }
        }
      })
      return obj;
    })
    requestForUpdate(payload)
      .then((res) => {
        // console.log(newData);
        if (res !== undefined) {
          toast.success(successfulHelpful(res.data.message), {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((err) => {});
  };
  const onClickButton = (key) => {
    // console.log("");
  };
  const onClickShareButton = () => {
    advanceFilterModalToggle({ bool: true, value: "shareQuestion" });
    getSelectedQuestion(question);
  };
  const onClickRFU = () => {
    advanceFilterModalToggle({ bool: true, value: "requestForUpdate" });
    getSelectedAnswer(data);
    getSelectedQuestion(question);
  };
  const stripHtml=(htmlString)=>{
    return htmlString
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n\n")
    .replace(/<\/?[^>]+(>|$)/g, "");
  }
  const success = () => {
    messageApi.info("hl");
  };
const onClickCopy=(text)=>{
  toast.success(successfulHelpful("Text copied!"), {
    position: toast.POSITION.TOP_RIGHT,
  });
    let newString = stripHtml(data.answer);
    navigator.clipboard.writeText(`${question.text}\n\n${newString}`);
}
const onClickPlayPause=()=>{
  setPlay(!isPlay);
  // if(isPlay){
  //   document.getElementById(`${question.questionUuid}_${randomNumber}`).pause();
  // }else{
  //   document.getElementById(`${question.questionUuid}_${randomNumber}`).play();
  // }
}

const firstThread = {
  width: "95%",
  minHeight: "44px",
  border: "1px solid rgb(224, 226, 230)",
  padding: "10px 12px",
  borderRadius: "8px",
  background: "rgb(246, 247, 248)",
  color: "rgb(42, 54, 74)",
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 300,
  marginLeft: "5%",
  marginBlock: "5px",
  wordBreak: 'break-word',overflowWrap: 'break-word',
};

const replyThread = {
  width: "85%",
  minHeight: "44px",
  border: "1px solid rgb(224, 226, 230)",
  padding: "10px 12px",
  borderRadius: "8px",
  background: "rgb(255, 255, 255)",
  color: "rgb(92, 102, 123)",
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 300,
  marginLeft: "15%",
  marginBottom: "5px",
  wordBreak: 'break-word',overflowWrap: 'break-word',
};
  return (
    <>
    {data.attachmentVideo && data.attachmentVideo.length > 0 && (
            <>
            <div className="mt-1" style={{textAlign:'right'}}><Button type={'primary'} text={isPlay?'Hide Video':'Show Video'} onClickFunc={onClickPlayPause}/></div>
            {isPlay && <div className="mb-4 mt-3" style={{textAlign:'center'}}>
              <div>
                <video
                 id={`${question.questionUuid}_${randomNumber}`}
                  controls
                  onBlur={()=>handlePauseAllVideo()}
                  style={contentStyle}
                >
                  <source
                    src={`${data.attachmentVideo[0].objectUrl}#t=${data.startTime},${data.endTime}`}
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>}
            </>
          )}
      { data.attachmentURL && data.attachmentURL.length > 0 && (
            <div className="mb-4 mt-3">
              <div>
              <ImgCarousal data={data.attachmentURL}/>
              </div>
            </div>
          )}
      {
         data.answer!==null &&data.answer.includes('vizsep') &&
        // <Thread type={'thread'} thread={data.threads} isShow={isShow} isReusable={question.threadType === 'REUSABLE_THREAD_QA' ? true : false} />
        (
          <>
          <div style={firstThread} dangerouslySetInnerHTML={{__html:data.answer!== null && data.answer.split('vizsep') && data.answer.split('vizsep')[0]}} />
          {question.reusableThreadQA && (
            <div style={firstThread} dangerouslySetInnerHTML={{__html:data.answer.split('vizsep') && data.answer.split('vizsep')[1]}} />          )}
            {/* {data.answer.split('vizsep').map((obj,ind)=>{
              if(ind !== 0)
              {
                return(<div style={replyThread}>{obj}</div>)
              }
            })} */}
            {
              data.answer !== null && question.reusableThreadQA === false && data.answer.includes('vizsep') && data.answer.split('vizsep')[1] && 
              (
                <>
                <div style={replyThread} dangerouslySetInnerHTML={{__html:data.answer.split('vizsep')[1]}} />
                </>
              )
            }
          </>
        )
      }
      {
        data.answer!== null && data.answer.includes('vizsep') && !isShow &&
        (
          <span style={showThreadStyles} onClick={() => setShow(!isShow)}>Show full thread <ArrowDownIcon /></span>
        )
      }
      {
        data.answer !== null && data.answer.includes('vizsep') && data.answer.split('vizsep').length > 0 && isShow && (
          <>
          {data.answer.split('vizsep').map((obj, ind) => {
            if (ind !== 0 && ind !== 1) {
              return (
                <div style={replyThread} key={ind} dangerouslySetInnerHTML={{__html:obj}}></div>
              )
            }
          })}
          <span style={showThreadStyles} onClick={()=>setShow(!isShow)}>Hide full thread <ArrowUpIcon /></span>
          </>
        )
      }
     {!data.answer.includes('vizsep') && <div
        style={ansStyles}
        dangerouslySetInnerHTML={{
          __html: !isShow
            ? removeStylesFromHtml(
                trimString(
                  data.answer === null
                    ? question.contextData
                    : data.answer
                )
              )
            : removeStylesFromHtml(
                data.answer === null
                  ? question.contextData
                  : data.answer
              ),
        }}
      ></div>}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "10px",
        }}
      >
        <div>
          {data.answer !== null
            ? data.answer.length > 350 &&
              !isShow && !data.answer.includes('vizsep')&& (
                <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                  Show more&nbsp;
                  <ArrowDownIcon />
                </div>
              )
            : question.contextData.length > 350 &&
              !isShow && (
                <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                  Show more&nbsp;
                  <ArrowDownIcon />
                </div>
              )}
          {data.answer !== null
            ? data.answer.length > 350 &&
              isShow && !data.answer.includes('vizsep') && (
                <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                  Show less&nbsp;
                  <ArrowUpIcon />
                </div>
              )
            : question.contextData.length > 350 &&
              isShow && (
                <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                  Show less&nbsp;
                  <ArrowUpIcon />
                </div>
              )}
        </div>
        {
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button2 type={"light"} onClickFunc={onClickCopy}>
              <CopyIcon />
            </Button2>
            &nbsp;
            {val !== 3 && question.status !== 'accepted' && <Button2 type={"light"} onClickFunc={onClickShareButton}>
              <ShareIcon />
            </Button2>}
            {/* {permission !== undefined && !data.userInitiatedCuration &&
                    data.expert.userUuidStr !==
                      userState.geoAttributes.userId &&
                      (data.curationCategory !== 1 ||
                        data.curationStatus !== "pending") &&<>
              &nbsp;
            <Button2 type={"dark"} onClickFunc={onClickRFU}>
              <RFUIcon />
              &nbsp;Request for update
            </Button2>
            </>} */}
            {/* {permission !== undefined && !data.userInitiatedCuration &&
                    data.expert.userUuidStr !==
                      userState.geoAttributes.userId &&
                      data.curationCategory === 1 &&
                        data.curationStatus === "pending" &&<>
              &nbsp;
            <Button2 type={"dark"} onClickFunc={onClickRFU}>
              <RFUIcon />
              &nbsp;Request for update
            </Button2>
            </>} */}
            &nbsp;
            <Button2 onClickFunc={onClickButton}>
              <Rating id={data.docId===undefined?data.answerUuid:data.docId} />
            </Button2>
          </div>
        }
        {/* {question.docType !== "expertqa" && question.docType !== "Email" && (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button2 type={"light"} onClickFunc={onClickCopy} >
              <CopyIcon  />
            </Button2>
            &nbsp;
            <Button2 type={"dark"}>
              <VerifyIcon />
              &nbsp;Verify
            </Button2>
            &nbsp;
            <Button2 onClickFunc={onClickButton}>
              <Voting value={isAccept} onClickFunc={onClickVote} />
            </Button2>
          </div>
        )} */}
      </div>
    </>
  );
}
